import PropTypes from "prop-types";
import Mobile from "./mobile";
import Desktop from "./desktop";

const SearchHistory = ({ isMobile, ...restProps }) => {

	if (isMobile) {

		return <Mobile {...restProps} />;

	}

	return <Desktop {...restProps} />;

};

SearchHistory.propTypes = {
	isMobile: PropTypes.bool,
};

SearchHistory.defaultProps = {
	isMobile: false,
};

export default SearchHistory;
